import type { SVGProps } from 'react';

const SvgPickLt = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      d='M11.2822 2.97266C11.5802 2.34218 12.4198 2.34218 12.7178 2.97266L15.0254 7.85742C15.1406 8.10116 15.3691 8.28123 15.6455 8.32324L20.8066 9.10645C21.4437 9.20314 21.7571 10.0667 21.248 10.585L17.5137 14.3867C17.3231 14.5808 17.241 14.8543 17.2842 15.1172L18.165 20.4854C18.2885 21.2372 17.5538 21.7027 17.0068 21.4023L12.3906 18.8672C12.1774 18.7502 11.9259 18.7356 11.7031 18.8232L11.6094 18.8672L6.99316 21.4023C6.44621 21.7027 5.7115 21.2372 5.83496 20.4854L6.71582 15.1172C6.759 14.8543 6.67692 14.5808 6.48633 14.3867L2.75195 10.585C2.24292 10.0667 2.55626 9.20314 3.19336 9.10645L8.35449 8.32324C8.63096 8.28123 8.85945 8.10113 8.97461 7.85742L11.2822 2.97266Z'
      stroke='currentColor'
    />
  </svg>
);
export default SvgPickLt;
